module.exports = __webpack_public_path__ + "static/media/2.9a5958b7.png";